import { render, staticRenderFns } from "./packagesMobileDropdown.vue?vue&type=template&id=6e672f40&scoped=true"
import script from "./packagesMobileDropdown.vue?vue&type=script&lang=js"
export * from "./packagesMobileDropdown.vue?vue&type=script&lang=js"
import style0 from "./packagesMobileDropdown.vue?vue&type=style&index=0&id=6e672f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e672f40",
  null
  
)

export default component.exports